import React from "react";
import { connect } from "react-redux";
import ReadMore from "../../common/ReadMore";

import GalleryModal from "./components/Gallery.modal";
import ListModal from "./components/List.modal";
import TitleModal from "./components/Title.modal";

const HatChefBody = ({ modalRedux }) => {
  const {
    staticContent: {
      markerInfo: { data, title }
    }
  } = modalRedux;

  return (
    <>
      <div className="col-12">
        <TitleModal title={title} />
      </div>
      <div className="col-12 col-lg-6" style={{ position: "relative" }}>
        <GalleryModal gallery={data.img} />
      </div>

      <div className="col-12 col-lg-6">
        <h6
          style={{
            fontWeight: "bold",
            marginBottom: "5px"
          }}
        >
          Ingredienti
        </h6>
        <ListModal list={data.ingredients} />
      </div>
      <div className="col-12 mt-3">
        <h6
          style={{
            fontWeight: "bold",
            marginBottom: "5px"
          }}
        >
          Procedimento
        </h6>
        <ReadMore limit={9999}>{data.recipe}</ReadMore>
      </div>
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    modalRedux: state.modal
  };
};
export default connect(mapStateToProps)(HatChefBody);
